import { useT } from "../i18n";
import { useTheme, type Theme } from "../lib/theme";

const icons: Record<Theme, { path: React.ReactNode }> = {
  light: {
    path: (
      <>
        <circle cx="12" cy="12" r="4" />
        <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41" />
      </>
    ),
  },
  system: {
    path: (
      <>
        <rect width="20" height="14" x="2" y="3" rx="2" />
        <path d="M8 21h8M12 17v4" />
      </>
    ),
  },
  dark: {
    path: <path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z" />,
  },
};

export function ThemeToggle() {
  const [theme, setTheme] = useTheme();
  const t = useT();

  return (
    <div
      role="radiogroup"
      aria-label={t.menu.design}
      className="inline-flex items-center gap-0.5 rounded-lg border border-zinc-200 bg-white p-0.5 dark:border-zinc-800 dark:bg-zinc-900"
    >
      {(Object.keys(icons) as Theme[]).map((mode) => (
        <button
          key={mode}
          role="radio"
          aria-checked={theme === mode}
          title={t.theme[mode]}
          onClick={() => setTheme(mode)}
          className={`rounded-md p-1.5 transition-colors ${
            theme === mode
              ? "bg-zinc-100 text-zinc-900 dark:bg-zinc-700 dark:text-zinc-50"
              : "text-zinc-400 hover:text-zinc-600 dark:text-zinc-500 dark:hover:text-zinc-300"
          }`}
        >
          <svg
            width="15"
            height="15"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            {icons[mode].path}
          </svg>
        </button>
      ))}
    </div>
  );
}
